import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getAllSubjectData,
  getSubjectData,
} from "../../redux/services/subjectSlice";
import { useUser } from "../../redux/services/authSlice";
import Loading from "../../common/Loading";
import NoDataFound from "../../common/NoDataFound";

const SubjectPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classesId = localStorage.getItem("classesId");
  const { user } = useUser();
  const userId = user?._id;
  const [subjectData, setSubjectData] = useState([]);
  const mainSubjectData = useSelector((state) => state?.subject?.staticData);
  const [page, setPage] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const limit = 12;

  const getAllSubjectWiseData = useCallback(async () => {
    try {
      await dispatch(getSubjectData());
    } catch (error) {
      console.error("Failed to fetch subject-wise data", error);
    }
  }, [dispatch]);

  const getAllSubjectsData = useCallback(
    async (currentPage) => {
      setLoading(true);
      try {
        const response = await dispatch(
          getAllSubjectData({
            page: currentPage,
            limit,
            classesFilter: userId || classesId,
          })
        );
        const fetchedData = response.payload?.data.subject_data || [];
        const totalRecords = response.payload?.data?.state?.page_limit || 0;
        setSubjectData((prevData) => [...prevData, ...fetchedData]);
        setTotalData(totalRecords);
      } catch (error) {
        console.error("Failed to fetch all subject data", error);
      } finally {
        setLoading(false);
      }
    },
    [dispatch, limit, userId,classesId]
  );

  useEffect(() => {
    getAllSubjectWiseData(page);
  }, [getAllSubjectWiseData, page]);

  useEffect(() => {
    if (userId || classesId) {
      getAllSubjectsData(page);
    }
  }, [getAllSubjectsData, page, userId,classesId]);

  const handleLoadMore = () => {
    setPage((prevPage) => prevPage + 1);
  };
  return (
    <section className="h-full">
      <div className="p-4 h-full">
        {loading ? (
          <Loading />
        ) : subjectData?.length > 0 ? (
          <div className="grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-6 lg:grid-cols-3 lg:gap-2 xl:grid-cols-4 xl:gap-3 2xl:grid-cols-4 2xl:gap-6">
            {subjectData?.map((value, index) => {
              return (
                <div
                  className="bg-white shadow-md border rounded-lg p-5 space-y-4 cursor-pointer"
                  onClick={() => {
                    localStorage.setItem(
                      "subjectDetails",
                      JSON.stringify({ id: value?._id, name: value?.name,isFullLength:value?.isFullLength,isSubjectShow:value?.isSubjectShow })
                    );
                    navigate(`/subjectDetails?subjectId=${value?._id}`, {
                      state: { name: value?.name },
                    });
                  }}
                  key={index}
                >
                  <div className="flex flex-row items-center justify-between">
                    <p className="font-semibold text-left text-xl uppercase text-[#124699] w-[calc(100%-100px)]">
                      {value.name}
                    </p>
                    <div className="h-[50px] w-[50px]">
                      <img
                        src={value?.image}
                        className="block shadow-sm rounded-md h-full w-full"
                        alt={value.name}
                      />
                    </div>
                  </div>
                  <div className="text-left">
                    <p className="font-medium text-slate-600 text-xl capitalize">
                      Total Questions
                    </p>
                    <p className="text-2xl text-gray-800 font-medium">
                      {mainSubjectData?.find((x) => x?._id === value?._id)
                        ?.count || 0}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <NoDataFound />
        )}
        {page < totalData && (
          <div className="text-center my-6">
            <button
              className="bg-[#124699] text-white py-2 px-4 rounded-md hover:bg-[#124699]"
              onClick={handleLoadMore}
              disabled={loading}
            >
              {loading ? "Loading..." : "Load More..."}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default SubjectPage;







  // const generatePDF = async () => {
  //   const doc = new jsPDF();
  //   const pageWidth = doc.internal.pageSize.width;
  //   const margin = 8;
  //   const maxYPosition = 270;
  //   const textWidth = pageWidth - 4 * margin;
  //   const logoWidth = 20;
  //   const logoHeight = 20;
  //   const topMargin = margin;
  //   const leftMargin = margin;
  //   const rightMargin = margin;
  //   const bottomMargin = margin;
  //   let y = topMargin;
  //   const addHeader = () => {
  //     doc.addImage(logo, "JPEG", leftMargin, y, logoWidth, logoHeight);
  //     doc.link(leftMargin, y, logoWidth, logoHeight, {
  //       url: "https://hkdigiverse.com",
  //     });
  //     doc.setFontSize(16);
  //     doc.setFont("helvetica", "bold");
  //     const textX = leftMargin + logoWidth + 5;
  //     doc.setTextColor("#E96D22");
  //     const bharatText = "BHARAT";
  //     doc.text(bharatText, textX, y + 10);
  //     const bharatWidth = doc.getTextWidth(bharatText);
  //     doc.setTextColor(0, 0, 255);
  //     const examText = "EXAM";
  //     doc.text(examText, textX + bharatWidth + 3, y + 10);
  //     const examWidth = doc.getTextWidth(examText);
  //     doc.setTextColor(0, 128, 0);
  //     const festText = "FEST";
  //     doc.text(festText, textX + bharatWidth + examWidth + 6, y + 10);
  //     const festWidth = doc.getTextWidth(festText);
  //     doc.link(textX, y + 8, bharatWidth, 10, {
  //       url: "https://hkdigiverse.com",
  //     });
  //     doc.link(textX + bharatWidth + 5, y + 8, examWidth, 10, {
  //       url: "https://hkdigiverse.com",
  //     });
  //     doc.link(textX + bharatWidth + examWidth + 10, y + 8, festWidth, 10, {
  //       url: "https://hkdigiverse.com",
  //     });
  //     const easyText = "LEARN AND EARN";
  //     const easyTextY = y + 16;
  //     doc.setFont("helvetica", "normal");
  //     doc.setFontSize(12);
  //     doc.setTextColor(0, 0, 0);
  //     doc.text(easyText, textX, easyTextY);
  //     doc.setFontSize(10);
  //     const address = [
  //       "S-251, Angel Business Center, near Sudama Chowk,",
  //       "Mota Varachha, Surat, Gujarat - 394101",
  //     ];
  //     address.forEach((line, index) => {
  //       doc.text(line, pageWidth - rightMargin, y + 5 + index * 6, {
  //         align: "right",
  //       });
  //     });
  //     y += 6 * address.length + 6;
  //     doc.setFont("helvetica", "bold");
  //     doc.text("Phone: +91 93279 97744", pageWidth - rightMargin, y, {
  //       align: "right",
  //     });
  //     y += 5;
  //     doc.line(leftMargin, y, pageWidth - rightMargin, y);
  //   };
  //   const addFooter = () => {
  //     doc.setFont("helvetica", "bold");
  //     const footerY = doc.internal.pageSize.height - bottomMargin;
  //     doc.setFontSize(10);
  //     doc.text("Email: ask@bharatexamfest.com", leftMargin, footerY);
  //     const poweredByText = "Powered By: HK Digiverse & IT Consultancy";
  //     doc.text(poweredByText, pageWidth - rightMargin, footerY, {
  //       align: "right",
  //     });
  //     const poweredByX =
  //       pageWidth - rightMargin - doc.getTextWidth(poweredByText);
  //     doc.link(poweredByX, footerY - 2, doc.getTextWidth(poweredByText), 10, {
  //       url: "https://hkdigiverse.com/",
  //     });
  //     const pageCount = doc.internal.getNumberOfPages();
  //     doc.text(`${pageCount}`, pageWidth / 2, footerY, { align: "center" });
  //   };
  //   const addNewPage = () => {
  //     doc.addPage();
  //     addFooter();
  //     doc.setFont("helvetica", "normal");
  //     doc.setFontSize(12);
  //     return 20;
  //   };
  //   addHeader();
  //   addFooter();
  //   doc.setFontSize(12);
  //   let yPosition = y + 10;
  //   doc.setFont("helvetica", "bold");
  //   doc.setFontSize(18);
  //   doc.text(`Subject: ${name}`, pageWidth / 2, yPosition, { align: "center" });
  //   yPosition += 10;
  //   doc.setFontSize(12);
  //   doc.text(`Total Questions: ${questionData?.totalData || 0}`, 10, yPosition);
  //   yPosition += 2;
  //   questionData?.question_data?.forEach((q, index) => {
  //     yPosition += 10;
  //     if (yPosition + 15 > maxYPosition) yPosition = addNewPage();
  //     const questionText = `${index + 1}. ${q.englishQuestion?.question}`;
  //     const questionLines = doc.splitTextToSize(questionText, textWidth);
  //     doc.setFont("helvetica", "bold");
  //     doc.text(questionLines, 10, yPosition);
  //     yPosition += questionLines.length * 7;
  //     yPosition += 1;
  //     if (
  //       q.questionType === "statement" &&
  //       q.englishQuestion?.statementQuestion
  //     ) {
  //       q.englishQuestion.statementQuestion.forEach((statement, index) => {
  //         const statementText = `Statement ${index + 1}: ${statement.combined}`;
  //         const statementLines = doc.splitTextToSize(statementText, textWidth);
  //         if (yPosition + statementLines.length * 7 > maxYPosition) {
  //           yPosition = addNewPage();
  //         }
  //         doc.setFont("helvetica", "normal");
  //         doc.setTextColor(0, 0, 0);
  //         doc.text(statementLines, 10, yPosition);
  //         yPosition += statementLines.length * 7;
  //       });
  //       if (q.englishQuestion.lastQuestion) {
  //         if (yPosition + 15 > maxYPosition) {
  //           yPosition = addNewPage();
  //         }
  //         const lastQuestionText = `${q.englishQuestion.lastQuestion}`;
  //         const lastQuestionLines = doc.splitTextToSize(
  //           lastQuestionText,
  //           textWidth
  //         );
  //         doc.setFont("helvetica", "normal");
  //         doc.setTextColor(0, 0, 0);
  //         doc.text(lastQuestionLines, 10, yPosition);
  //         yPosition += lastQuestionLines.length * 7;
  //       }
  //     }
  //     if (q.questionType === "pair" && q.englishQuestion?.pairQuestion) {
  //       const tableMargin = 10;
  //       let startY = yPosition;
  //       const tableData = q.englishQuestion.pairQuestion.map((pair) => {
  //         const parts = pair.combined.split(" --- ");
  //         return parts;
  //       });
  //       const table1Data = q.englishQuestion.pairQuestion
  //         .slice(1)
  //         .map((pair) => {
  //           const parts = pair.combined.split(" --- ");
  //           return parts;
  //         });
  //       const headers =
  //         tableData.length > 0 ? tableData[0].map((part, index) => part) : [];
  //       if (yPosition + 15 > maxYPosition) {
  //         yPosition = addNewPage();
  //       }
  //       doc.autoTable({
  //         startY: startY,
  //         head: [headers],
  //         body: table1Data,
  //         margin: { top: tableMargin },
  //         theme: "grid",
  //         headStyles: {
  //           fillColor: "#124699",
  //           textColor: "#fff",
  //           fontStyle: "bold",
  //           cellPadding: 5,
  //         },
  //         styles: {
  //           font: "helvetica",
  //           fontSize: 10,
  //           cellPadding: 4,
  //           lineColor: [0, 0, 0],
  //           lineWidth: 0.1,
  //         },
  //         bodyStyles: {
  //           fillColor: "#f5f5f5",
  //           textColor: "#000",
  //           fontSize: 10,
  //           cellPadding: 4,
  //         },
  //       });
  //       yPosition = doc.lastAutoTable.finalY + 10;
  //       if (q.englishQuestion.lastQuestion) {
  //         if (yPosition + 15 > maxYPosition) {
  //           yPosition = addNewPage();
  //         }
  //         const lastQuestionText = ` ${q.englishQuestion.lastQuestion}`;
  //         const lastQuestionLines = doc.splitTextToSize(
  //           lastQuestionText,
  //           textWidth
  //         );
  //         doc.setFont("helvetica", "normal");
  //         doc.setTextColor(0, 0, 0);
  //         doc.text(lastQuestionLines, tableMargin, yPosition);
  //         yPosition += lastQuestionLines.length * 7;
  //       }
  //     }
  //     if (q.englishQuestion?.options) {
  //       doc.setFont("helvetica", "normal");
  //       doc.setTextColor(0, 0, 0);
  //       ["A", "B", "C", "D"].forEach((optionKey) => {
  //         if (q.englishQuestion.options[optionKey]) {
  //           const optionText = `${optionKey}) ${q.englishQuestion.options[optionKey]}`;
  //           const optionLines = doc.splitTextToSize(optionText, textWidth);
  //           if (yPosition + optionLines.length * 7 > maxYPosition)
  //             yPosition = addNewPage();
  //           doc.text(optionLines, 15, yPosition);
  //           yPosition += optionLines.length * 7;
  //         }
  //       });
  //     }
  //     if (q.englishQuestion?.answer) {
  //       if (yPosition + 10 > maxYPosition) yPosition = addNewPage();
  //       doc.setFont("helvetica", "bold");
  //       doc.setTextColor(0, 128, 0);
  //       const correctAnswerText = `Correct Answer: ${q.englishQuestion.answer}`;
  //       doc.text(correctAnswerText, 10, yPosition);
  //       yPosition += 6;
  //     }
  //     doc.setFont("helvetica", "normal");
  //     doc.setTextColor(0, 0, 0);
  //     yPosition += 2;
  //     const solutionText = `Solution: ${q.englishQuestion?.solution}`;
  //     const solutionLines = doc.splitTextToSize(solutionText, textWidth);
  //     solutionLines.forEach((line, lineIndex) => {
  //       if (yPosition + 7 > maxYPosition) yPosition = addNewPage();
  //       doc.text(line, 10, yPosition);
  //       yPosition += 7;
  //     });
  //     yPosition += 1;
  //     const lineYPosition = yPosition;
  //     doc.setLineWidth(0.5);
  //     doc.line(margin, lineYPosition, pageWidth - margin, lineYPosition);
  //   });
  //   addFooter();
  //   doc.save(`${name}-Questions.pdf`);
  // };
